import React, { useState, useEffect } from 'react';
import { formatDate, handleClickLinks } from '../includes/utils';
import PropTypes from "prop-types";
export default function CsfFournisseurActivitiesListTable({ sorting, sortingDirection, sortingTerm, handleSortingClick, formations, urlDetailFormation, handleStatusFilterChange }) {

  const langcode = document.documentElement.lang;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Initial width

  const filterChoices = [
    { valueFr: 'Brouillon', valueEn: 'Draft' },
    { valueFr: 'En attente d\'analyse', valueEn: 'Waiting for analysis' },
    { valueFr: 'En attente d\'information(s)', valueEn: 'Waiting for information(s)' },
    { valueFr: 'Reconnue - Activation à venir', valueEn: 'Acknowledged - Activation to come' },
    { valueFr: 'Reconnue - Active', valueEn: 'Acknowledged - Active' },
    { valueFr: 'Reconnue - Inactive', valueEn: 'Acknowledged - Inactive' },
    { valueFr: 'Refusée', valueEn: 'Refused' },
    { valueFr: 'Annulée', valueEn: 'Cancelled' },
  ];

  useEffect(() => {
    // Function to handle window resize
    const handleResize = () => setWindowWidth(window.innerWidth);

    // Add event listener on component mount
    window.addEventListener('resize', handleResize);

    // Cleanup function to remove listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // désélectionner le select qui ne fait pas partie du filtre actuel
    // doit passer par jquery pour changer la valeur:
    // https://developer.snapappointments.com/bootstrap-select/methods/
    if (sorting === 'Name_French') {
      $('#DateSelectFilter').selectpicker('val', '');

    } else if (sorting === 'StartDate' || sorting === 'EndDate') {
      $('#NameSelectFilter').selectpicker('val', '');

    }

  }, [sorting, sortingDirection]);

  useEffect(() => {
    $(".selectpicker").selectpicker("refresh");
  }, []);

  return (
    <div className="table-wrapper">
      <table id="activity-list-table" className="activity-list-table">
        <caption id="activity-list-caption" className="sr-only">{window.Drupal.t('fournisseur.activities-list.title')}</caption>
        <thead>
          <tr>
            <th aria-sort={sorting === 'Name_French' ? sortingTerm : 'none'}>

              <select className="selectpicker"
                id={'NameSelectFilter'}
                multiple data-max-options="1"
                data-none-selected-text={window.Drupal.t('fournisseur.activities-list.table.name')}
                onChange={(evt) => {
                  if (evt.target.value === 'asc') {
                    handleSortingClick("Name_French", 'asc');
                  }
                  else {
                    handleSortingClick("Name_French", 'desc');
                  }
                }}>
                <option value={'asc'}>{window.Drupal.t('fournisseur.activities-list.table.name.a-to-z')}
                </option>
                <option value={'desc'}>{window.Drupal.t('fournisseur.activities-list.table.name.z-to-a')}
                </option>

              </select>

            </th>
            <th width="36" className="list-item-status"></th>
            <th>

              <select className="selectpicker"
                multiple
                data-none-selected-text={window.Drupal.t('fournisseur.activities-list.table.status')}
                onChange={(event) => handleStatusFilterChange(event)}>
                {filterChoices.map(choice => (
                  <option key={choice.valueFr} value={choice.valueFr}>
                    {langcode === 'en' ? (
                      <>{choice.valueEn}</>
                    ) : (
                      <>{choice.valueFr}</>
                    )}
                  </option>
                ))}
              </select>

            </th>
            <th aria-sort={sorting === 'EndDate' ? sortingTerm : 'none'}>
              <select className="selectpicker"
                id={'DateSelectFilter'}
                multiple data-max-options="1"
                data-none-selected-text={window.Drupal.t('fournisseur.activities-list.table.period')}
                onChange={(evt) => {
                  if (evt.target.value === 'start-ascending') {
                    handleSortingClick("StartDate", 'asc');
                  }
                  else {
                    handleSortingClick("EndDate", 'asc');
                  }
                }}
              >
                <option value={'start-ascending'} >
                  {window.Drupal.t('fournisseur.activities-list.table.period.start-ascending')}
                </option>
                <option value={'end-ascending'}>
                  {window.Drupal.t('fournisseur.activities-list.table.period.end-ascending')}
                </option>

              </select>
            </th>
            <th width="100"></th>
          </tr>
        </thead>
        <tbody>
          {formations.length === 0 ? (
            <tr>
              <td colSpan="6">
                <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
              </td>
            </tr>
          ) : (
            formations.map(item => (
              <tr key={item.REDU_Activity_Id}>
                <td className="list-item-title">
                  {windowWidth < 1440 ? (
                    <>
                      {item.Name_French && (
                        <span className="prim" data-toggle="tooltip" title={item.Name_French}>{item.Name_French}</span>
                      )}
                      {item.Name_English && (
                        <span className="sec" data-toggle="tooltip" title={item.Name_English}>{item.Name_English}</span>
                      )}
                    </>
                  ) : (
                    <>
                      {item.Name_French && (
                        <span className="prim">{item.Name_French}</span>
                      )}
                      {item.Name_English && (
                        <span className="sec">{item.Name_English}</span>
                      )}
                    </>
                  )}
                </td>
                <td className="list-item-status">
                  {item.Flag === 1 && (
                    <img src="/themes/custom/tink/dist/assets/icn-warning.svg" data-toggle="tooltip"
                      title={item.Flag__Choice} alt="Tooltip icon" />
                  )}
                  {item.Flag === 2 && (
                    <img src="/themes/custom/tink/dist/assets/icn-error.svg" data-toggle="tooltip"
                      title={item.Flag__Choice} alt="Tooltip icon" />
                  )}
                </td>
                <td className="list-item-activity">
                  <span className="prim">{langcode === 'fr' ? item.Status_Name_French : item.Status_Name_English}</span>
                  {item.LastModif && (
                    <span className="sec" dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.last.modification.date.html') + ' ' + formatDate(item.LastModif) }}></span>
                  )}
                </td>
                <td className="list-item-validity">
                  <span className="prim">
                    {item.StartDate && (
                      <>
                        {formatDate(item.StartDate, '2-digit')}
                        {item.EndDate && (
                          <> - {formatDate(item.EndDate, '2-digit')}</>
                        )}
                      </>
                    )}
                  </span>
                  {item.Recognition_Code && (
                    <span className="sec">#{item.Recognition_Code}</span>
                  )}

                </td>
                <td>
                  <button className={item.Flag !== 0 ? "button" : "button btn-outlined"} aria-label={`${window.Drupal.t('fournisseur.open.btn.label')} ${item.Name_French} ${(item.Name_English ? " / " + item.Name_English : "")}`} onClick={() => handleClickLinks(urlDetailFormation, 'activity', item.REDU_Activity_Id)}>
                    {window.Drupal.t('fournisseur.open.btn.label')}
                  </button>
                </td>
              </tr>
            )))}
        </tbody>
      </table>
    </div>
  )
}

CsfFournisseurActivitiesListTable.propTypes = {
  sorting: PropTypes.string,
  sortingDirection: PropTypes.string,
  sortingTerm: PropTypes.string,
  handleSortingClick: PropTypes.func,
  formations: PropTypes.array,
  urlDetailFormation: PropTypes.string,
  handleStatusFilterChange: PropTypes.func
};
